import type { TFlowKind } from '@besuites/auth/flow';
import type { TypeFlowScreen } from '@/types/auth/types.auth.flow';

const SECOND_FACTOR = 'VERIFICA IN DUE PASSAGGI';

export default function flowTitleOf(kind: TFlowKind, screen: TypeFlowScreen, fallback: string): string {
    switch (screen.id) {
        case 'password': return kind === 'sign-in' ? 'ACCEDI AL TUO ACCOUNT' : 'CONFERMA CHE SEI TU';
        case 'new-password': return kind === 'recovery' ? 'SCEGLI UNA NUOVA PASSWORD' : 'SCEGLI LA PASSWORD';
        case 'email-code': return 'CONTROLLA LA POSTA';
        case 'totp':
        case 'recovery-code': return SECOND_FACTOR;
        case 'totp-setup': return 'ATTIVA L’APP DI AUTENTICAZIONE';
        case 'passkey': return screen.registering ? 'CREA UNA PASSKEY' : kind === 'sign-in' ? 'ACCEDI CON LA PASSKEY' : 'CONFERMA CON LA PASSKEY';
        case 'profile': return 'I TUOI DATI';
        case 'recovery-codes': return 'SALVA I CODICI DI RECUPERO';
        case 'stuck': return 'PROCEDURA INTERROTTA';
        default: return fallback;
    }
}
